import { z, ZodType } from 'zod';

export type CountResponse = {
	count: number;
};

export const countResponseSchema: ZodType<CountResponse> = z.object({ count: z.number() });
